import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import TextInput from '../../widgets/components/Input/TextInput'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
import * as Yup from 'yup'
import { Form, Formik } from 'formik'
import { CustomButton } from '../../widgets/components/UI/CustomButton'
import {
  errorMessage,
  nylasGoogleInitialValues,
  nylasMicrosoftInitialValues,
  senderInitialValues,
} from '../core/_constants'
import '../../profile/styles/index.scss'
// import {InfoCard} from '../../widgets/components/UI/InfoCard'
import { createSenderProfileInfo, getUserInfo, disconnectNylas } from '../core/_requests'
// import {createSenderProfileInfo, getNylasOauthUrl} from '../core/_requests'
// import {createSenderProfileInfo, updateIsActive, getNylasOauthUrl} from '../core/_requests'
import { toast } from 'react-toastify'
import ConnectAccountModal from './ConnectAccountModal'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import ConfirmationModal from './DeleteConfirmation'
import { useAuth } from '../../auth'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { Quill } from '../../widgets/components/Input/Quill'
import brandingConfig from '../../../../config/brandingConfig'

export const TransactionalEmailIntegration = ({
  key,
  companyId,
  getMailInformation,
  nylasGoogleRadio,
  nylasMicrosoftRadio,
  nylasEmailSignature,
  connectedAccount,
  setconnectedAccount,
}: {
  key: number
  companyId?: number
  getMailInformation: () => Promise<void>
  nylasGoogleRadio?: any
  nylasMicrosoftRadio?: any
  nylasEmailSignature: string
  connectedAccount: any
  setconnectedAccount: any
}) => {
  const { formatMessage } = useIntl()
  // const [collapsePostmark, setCollapsePostmark] = useState(true)
  // const [collapseFoundercrate, setCollapseFoundercrate] = useState(true)
  const [accountType, setaccountType] = useState('')
  const [senderLoading, setSenderLoading] = useState(false)
  const [sendTestEmailLoading] = useState(false)
  const [errorValue, setErrorValue] = useState(false)
  // const editorRef = useRef<any>(null)
  const [userLoading, setuserLoading] = useState(false)
  const [userInfo, setuserInfo] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const [userName, setuserName] = useState('')
  const [userEmail, setuserEmail] = useState('')
  const { setShowBillingModal, currentUser } = useAuth()
  const [quillText, setQuillText] = useState('')

  const senderSchema = Yup.object().shape({
    fromName: Yup.string()
      .min(1, formatMessage({ id: 'Minimum 1 character is required' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'Inverstor relation is required' }))
      .nullable(),
    fromEmail: Yup.string()
      .min(1, formatMessage({ id: 'Minimum 1 character is required' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'Investor email is required' }))
      .nullable(),
    replyToName: Yup.string()
      .min(1, formatMessage({ id: 'Minimum 1 character is required' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'Investor name is required' }))
      .nullable(),
    replyToEmail: Yup.string()
      .min(1, formatMessage({ id: 'Minimum 1 character is required' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'Investor email is required' }))
      .nullable(),
  })

  const onSubmit = async (values: any) => {
    console.log('chekci', values)
    console.log(sendTestEmailLoading)
  }

  const onSubmitSender = async (values: any) => {
    try {
      if (quillText.length === 0) {
        setErrorValue(true)
        return
      }
      setSenderLoading(true)
      const {
        data: { success, errors },
      } = await createSenderProfileInfo({
        companyId,
        nylasFromName: values.nylasFromName,
        nylasFromAddress: values.nylasFromEmail,
        nylasReplyToName: values.nylasReplyToName,
        nylasReplyToAddress: values.nylasReplyToEmail,
        nylasEmailSignature: quillText,
      })
      if (success) {
        setErrorValue(false)
        setSenderLoading(false)
        toast.success(formatMessage({ id: 'Sender profile updated' }))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CreateSenderProfileInfoSuccessful,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              nylas_from_name: values.nylasFromName,
              nylas_from_address: values.nylasFromEmail,
              nylas_reply_to_name: values.nylasReplyToName,
              nylas_reply_to_address: values.nylasReplyToEmail,
            },
          },
        })
      } else {
        setErrorValue(false)
        setSenderLoading(false)
        errors.forEach((error: string) => {
          if (
            error === errorMessage.UPGRADE_BILLING_PLAN_LIMIT_EXCEEDED ||
            error === errorMessage.UPGRADE_BILLING_PLAN_FEATURE
          ) {
            setShowBillingModal(true)
            toast.error(formatMessage({ id: error }), { autoClose: false })
          } else {
            toast.error(formatMessage({ id: error }))
          }
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CreateSenderProfileInfoFailed,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              nylas_from_name: values.nylasFromName,
              nylas_from_address: values.nylasFromEmail,
              nylas_reply_to_name: values.nylasReplyToName,
              nylas_reply_to_address: values.nylasReplyToEmail,
              error: errors[0],
            },
          },
        })
      }
    } catch (err) {
      setErrorValue(false)
      setSenderLoading(false)
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CreateSenderProfileInfoFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            nylas_from_name: values.nylasFromName,
            nylas_from_address: values.nylasFromEmail,
            nylas_reply_to_name: values.nylasReplyToName,
            nylas_reply_to_address: values.nylasReplyToEmail,
            error: err,
          },
        },
      })
    }
  }
  const [isActive, setIsActive] = useState(false)

  function handleIsActive() {
    setIsActive(() => !isActive)
  }

  const getUserInformation = async () => {
    setuserLoading(true)
    try {
      const {
        data: { success, error, data },
      } = await getUserInfo(companyId!)
      if (success) {
        setuserInfo(data?.account?.data?.email)
        const firstName = data?.mailerData?.user?.firstName
        const lastName = data?.mailerData?.user?.lastName || ''
        setuserName(firstName + (lastName ? ` ${lastName}` : ''))
        setuserEmail(data?.mailerData?.user?.email)
        setuserLoading(false)
      } else {
        toast.error(formatMessage({ id: error }))
      }
    } catch (err) {
      console.log(err)
      toast.error(formatMessage({ id: "Something went wrong couldn't fetch user information." }))
    } finally {
      setuserLoading(false)
    }
  }

  const handleDisconnectButton = () => {
    setIsModalOpen(true)
  }

  const handleConfirmDisconnect = async () => {
    setIsProcessing(true)
    try {
      const isNylasActive = 'disconnect'
      const {
        data: { data, success, errors }, // eslint-disable-line
      } = await disconnectNylas(isNylasActive, companyId)

      if (success) {
        toast.success(formatMessage({ id: 'Account is successfully disconnected.' }))
        setconnectedAccount('')
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DisconnectNylasSuccessful,
            action: 'normal',
            metadata: {
              nylas_account: isNylasActive,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        toast.error(errors[0])
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DisconnectNylasFailed,
            action: 'normal',
            metadata: {
              nylas_account: isNylasActive,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: errors[0],
            },
          },
        })
      }
    } catch (error) {
      toast.error(formatMessage({ id: 'Something went wrong while disconnecting your account.' }))
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DisconnectNylasFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: error,
          },
        },
      })
    } finally {
      setIsProcessing(false)
      setIsModalOpen(false)
    }
  }

  useEffect(() => {
    if (connectedAccount) {
      getUserInformation()
    }
  }, [connectedAccount]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className='card row'>
        <div className='card-body p-3'>
          <div>
            <div>
              <h4 className='card-label'>
                {formatMessage({ id: 'Sender Profile For Transactional Emails' })}
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: 'This section configures how your emails appear to recipients. Professional email settings enhance credibility when communicating with stakeholders and ensure consistent branding across all platform communications.',
                  })}
                />
              </h4>
            </div>

            <div className='row mt-4 mb-4'>
              <div className='col-md-7'>
                <Formik
                  initialValues={senderInitialValues}
                  validationSchema={senderSchema}
                  onSubmit={onSubmitSender}
                >
                  {(formik) => {
                    return (
                      <Form>
                        <TextInput
                          fieldType={'text'}
                          label={formatMessage({ id: 'From Name' })}
                          fieldName={'nylasFromName'}
                          formik={formik}
                          placeholder={formatMessage({ id: 'eg. Records Updates' })}
                          toolTipText={formatMessage({
                            id: 'The name that will appear as the sender of emails sent through the service',
                          })}
                          width={14}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        <TextInput
                          fieldType={'text'}
                          label={formatMessage({ id: 'From Address' })}
                          fieldName={'nylasFromEmail'}
                          formik={formik}
                          placeholder={formatMessage({ id: 'eg. records@yourcompany.com' })}
                          toolTipText={formatMessage({
                            id: 'The email address that will appear as the sender. This should be a professional email address from your domain for credibility and deliverability.',
                          })}
                          width={14}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        <TextInput
                          fieldType={'text'}
                          label={formatMessage({ id: 'Reply-to Name' })}
                          fieldName={'nylasReplyToName'}
                          formik={formik}
                          placeholder={formatMessage({ id: 'eg. Records Updates' })}
                          toolTipText={formatMessage({
                            id: 'The name that will appear when recipients reply to your emails. This can be different from the sender name and helps direct responses to the appropriate person.',
                          })}
                          width={14}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        <TextInput
                          fieldType={'text'}
                          label={formatMessage({ id: 'Reply-to Address' })}
                          fieldName={'nylasReplyToEmail'}
                          formik={formik}
                          placeholder={formatMessage({ id: 'eg. records@yourcompany.com' })}
                          toolTipText={formatMessage({
                            id: 'The email address where replies will be sent. Setting a specific reply-to address ensures that responses are properly routed to the team member responsible for follow-up.',
                          })}
                          width={14}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        <div className='mb-5'>
                          <div className=''>
                            <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                              {formatMessage({ id: 'Email Signature' })}*{' '}
                              <ToolTipUI
                                tooltipText={formatMessage({
                                  id: 'Add your professional signature that appears at the bottom of all transactional emails.',
                                })}
                              />
                            </label>
                            <div>
                              <Quill
                                quillText={quillText}
                                setQuillText={setQuillText}
                                aiEmailResponse={nylasEmailSignature}
                                isError={true}
                              />
                            </div>

                            <div className='mt-2'>
                              {errorValue && (
                                <span className='text-danger font-size-13'>
                                  {formatMessage({ id: 'Email Signature Required' })}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='d-flex justify-content-end'>
                          <CustomButton
                            isSubmitting={formik.isSubmitting}
                            isValid={formik.isValid}
                            buttonText={formatMessage({ id: 'Save Changes' })}
                            loading={senderLoading}
                            widthLoading={2}
                            width={3}
                            onSubmit={formik.handleSubmit}
                          />
                        </div>
                      </Form>
                    )
                  }}
                </Formik>
              </div>
              <div className='col-md-5'>
                <div className='info-card important-notice-card'>
                  <div className='card mt-0 fs-6 flex-row mb-md-4 mb-8 '>
                    <div className='me-4'>
                      <img
                        src={toAbsoluteUrl('/media/icons/duotune/general/file_image.svg')}
                        alt=''
                      />
                    </div>
                    <div>
                      <div className=' fw-bold mb-1'>
                        {formatMessage({ id: 'How Transactions Email Integration Works?' })}
                      </div>
                      <div className='fw-normal'>
                        <p>
                          {formatMessage({
                            id: `You can connect either Google Workspace or Microsoft 365 Business account to ${brandingConfig.brandName} as part of transactional email integration. This powerful feature allows you to send focused, professional communications to your stakeholders directly from the platform.`,
                          })}
                        </p>
                        <p>
                          {formatMessage({
                            id: `The connected account will also be used in "Shared Access" section for the team's calendar, inbox & contacts management, creating a centralized communication hub.`,
                          })}
                        </p>
                        <p>
                          {formatMessage({
                            id: `This integration enables effective collaboration for your record management process while maintaining a single point of contact for all stakeholders.`,
                          })}
                        </p>
                        <p>
                          <strong>
                            {formatMessage({
                              id: `We highly recommend using a dedicated email address like records@yourcompany.com or compliance@yourcompany.com.`,
                            })}
                          </strong>
                        </p>
                      </div>

                      <div className='d-flex justify-content-end'>
                        <a
                          href='https://help.recordskeeper.ai/en/articles/10868016-how-to-configure-email-integration-in-recordskeeper-ai'
                          className='ms-1 link-primary'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {formatMessage({ id: 'Learn More' })}
                          <span className='ms-5'>
                            <img
                              src={toAbsoluteUrl('/media/icons/duotune/general/arrow-right.svg')}
                              alt=''
                            />
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className=''>
            <h4 className='card-label'>
              {formatMessage({ id: 'Transactions Email Integration' })}
              <ToolTipUI
                tooltipText={formatMessage({ id: 'This connection allows to send focused communications on your behalf.' })}
              />
            </h4>
          </div>

          {/* <div className='accordion' id='parent-accordion2'>
            <div className='row mt-4'>
              <div className='col-md-6'>
                <div>
                  <Formik initialValues={nylasGoogleInitialValues} onSubmit={onSubmit}>
                    {(formik) => {
                      return (
                        <Form>
                          <div className='accordion-item mailer-radio'>
                            <h2
                              className='accordion-header parent-accordion-user'
                              id='panelsStayOpen-headingFive'
                            >
                              <button
                                className={`bg-white accordion-button ${
                                  collapseFoundercrate ? 'hideIt' : ''
                                }`}
                                type='button'
                                data-bs-toggle='collapse'
                                data-bs-target='#panelsStayOpen-collapseFive'
                                aria-expanded='true'
                                aria-controls='panelsStayOpen-collapseFive'
                                onClick={() => {
                                  setCollapseFoundercrate(!collapseFoundercrate)
                                  setCollapsePostmark(true)
                                }}
                              >
                                <input
                                  onClick={() => {
                                    updateRadioButton('nylasGoogle')
                                  }}
                                  type='radio'
                                  id='nylasGoogle'
                                  name='radio_button'
                                  className='radio-btn'
                                  checked={nylasGoogleRadio}
                                />
                                <img
                                  src={toAbsoluteUrl('/media/auth/google-mini-logo.svg')}
                                  alt=''
                                  className='button-icon mt-5 ms-6'
                                />
                                <h6 className='font-weight-500 font-size-14 text-dark m-0'>
                                  {formatMessage({id: 'Google Workspace Email ID'})}
                                </h6>
                              </button>
                            </h2>
                            <div
                              id='panelsStayOpen-collapseFive'
                              className='accordion-collapse collapse'
                              aria-labelledby='panelsStayOpen-headingFive'
                              data-bs-parent='#parent-accordion2'
                            >
                              <div className='accordion-body'>
                                <p>
                                  {formatMessage({
                                    id: 'Google Workspace email service limits the amount of emails you can send in a day. Attempting to send large volumes of emails may result a significant delay in delivery and cause service interruption to other users.',
                                  })}
                                </p>
                                <div className='d-flex justify-content-end'>
                                  <button
                                    id='googleConnectButton'
                                    className='gsi-material-button w-100 w-md-auto'
                                    disabled={Boolean(formik.values.grantId)}
                                    onClick={() => {
                                      redirectToNylasOauthUrl('google')
                                    }}
                                  >
                                    <div className='gsi-material-button-state'></div>
                                    <div className='gsi-material-button-content-wrapper'>
                                      <div className='gsi-material-button-icon'>
                                        <svg
                                          version='1.1'
                                          xmlns='http://www.w3.org/2000/svg'
                                          viewBox='0 0 48 48'
                                          style={{display: 'block'}}
                                        >
                                          <path
                                            fill='#EA4335'
                                            d='M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z'
                                          ></path>
                                          <path
                                            fill='#4285F4'
                                            d='M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z'
                                          ></path>
                                          <path
                                            fill='#FBBC05'
                                            d='M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z'
                                          ></path>
                                          <path
                                            fill='#34A853'
                                            d='M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z'
                                          ></path>
                                          <path fill='none' d='M0 0h48v48H0z'></path>
                                        </svg>
                                      </div>
                                      <span className='gsi-material-button-contents'>
                                        {formatMessage({
                                          id: formik.values.grantId
                                            ? 'Email Account is Connected'
                                            : 'Connect Your Email Account',
                                        })}
                                      </span>
                                      <span style={{display: 'none'}}>
                                        {formatMessage({
                                          id: formik.values.grantId
                                            ? 'Email Account is Connected'
                                            : 'Connect Your Email Account',
                                        })}
                                      </span>
                                    </div>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )
                    }}
                  </Formik>
                </div>
              </div>
            </div>
            <div className='row mt-4'>
              <div className='col-md-6'>
                <div>
                  <Formik initialValues={nylasMicrosoftInitialValues} onSubmit={onSubmit}>
                    {(formik) => {
                      return (
                        <Form>
                          <div className='accordion-item mailer-radio'>
                            <h2
                              className='accordion-header parent-accordion-user'
                              id='panelsStayOpen-headingOne'
                            >
                              <button
                                className={`bg-white accordion-button ${
                                  collapsePostmark ? 'hideIt' : ''
                                }`}
                                type='button'
                                data-bs-toggle='collapse'
                                data-bs-target='#panelsStayOpen-collapseOne'
                                aria-expanded='true'
                                aria-controls='panelsStayOpen-collapseOne'
                                onClick={() => {
                                  setCollapsePostmark(!collapsePostmark)
                                  setCollapseFoundercrate(true)
                                }}
                              >
                                <input
                                  onClick={() => {
                                    updateRadioButton('nylasMicrosoft')
                                  }}
                                  type='radio'
                                  id='nylasMicrosoft'
                                  name='radio_button'
                                  className='radio-btn'
                                  checked={nylasMicrosoftRadio}
                                />
                                <img
                                  src={toAbsoluteUrl('/media/auth/microsoft-365-logo.svg')}
                                  alt=''
                                  className='button-icon mt-5 ms-6'
                                />
                                <h6 className='m-0 font-weight-500 font-size-14 text-dark'>
                                  {formatMessage({id: 'Microsoft 365 Business Email ID'})}
                                </h6>
                              </button>
                            </h2>
                            <div
                              id='panelsStayOpen-collapseOne'
                              className='accordion-collapse collapse'
                              aria-labelledby='panelsStayOpen-headingOne'
                              data-bs-parent='#parent-accordion2'
                            >
                              <div className='accordion-body'>
                                <p>
                                  {formatMessage({
                                    id: 'Microsoft 365 Business email service limits the amount of emails you can send in a day. Attempting to send large volumes of emails may result a significant delay in delivery and cause service interruption to other users.',
                                  })}
                                </p>
                                <div className='d-flex justify-content-end'>
                                  <div className='bsk-container'>
                                    <button
                                      id='microsoftConnectButton'
                                      className='bsk-btn'
                                      disabled={Boolean(formik.values.grantId)}
                                      onClick={() => {
                                        redirectToNylasOauthUrl('microsoft')
                                      }}
                                    >
                                      <object
                                        type='image/svg+xml'
                                        data={toAbsoluteUrl('/media/auth/microsoft-365-logo.svg')}
                                        className='x-icon'
                                        aria-label='Microsoft 365 Logo'
                                      ></object>
                                      <span className='bsk-btn-contents'>
                                        {formatMessage({
                                          id: formik.values.grantId
                                            ? 'Email Account is Connected'
                                            : 'Connect Your Email Account',
                                        })}
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className='mt-4 col-md-7'>
            <InfoCard
              title='How Email Integration Works?'
              desc={`<p>You can connect either Google Workspace or Microsoft 365 Business account to as a part of Transactional Email integration which allows you to send focused, transactional email to your internal investors.
              The connected account will also be used in “Shared Access” section for the team’s calendar, inbox & contacts.</p>
              <p>Depending on the team members’ role and access level, the connected account will be shared among multiple team members through the “Shared Access” section. This integration enables effective collaboration for your fundraising process while maintaining a single point of contact for internal investors.</p>
              <p><strong>We highly recommend to use something like invest@yourcompany.com or investor-relation@yourcompany.com.</strong></p>`}
              slug='#'
            />
          </div> */}
          {connectedAccount === '' || !userInfo ? (
            userLoading ? (
              <div>
                <Skeleton
                  width={200}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
                <Skeleton
                  count={2}
                  width={500}
                  style={{ marginTop: '12px' }}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
            ) : (
              <div className='d-flex justify-content-center align-items-center col-md-7 mb-10 mt-4'>
                <div
                  className='btn-group d-flex flex-md-row flex-column w-100 justify-content-between'
                  role='group'
                  aria-label='Connect buttons'
                >
                  <Formik initialValues={nylasGoogleInitialValues} onSubmit={onSubmit}>
                    {(formik) => {
                      return (
                        <Form className='w-100'>
                          <button
                            type='button'
                            id='googleConnectButton'
                            className='btn btn-lg rounded d-flex justify-content-center w-100'
                            style={{
                              border: '1px solid #4776E6',
                              color: '#4776E6',
                            }}
                            onClick={() => {
                              setaccountType('google')
                              handleIsActive()
                            }}
                          >
                            <img
                              src={toAbsoluteUrl('/media/auth/google-mini-logo.svg')}
                              alt='Google'
                              height={21}
                              width={21}
                              style={{ marginRight: '8px' }}
                            />
                            <p className='m-0 connected-acc-button-text'>
                              {formatMessage({ id: 'Connect Now' })}
                            </p>
                          </button>
                        </Form>
                      )
                    }}
                  </Formik>
                  <p className='align-self-center m-0 mx-2'>{formatMessage({ id: 'Or' })}</p>
                  <Formik initialValues={nylasMicrosoftInitialValues} onSubmit={onSubmit}>
                    {(formik) => {
                      return (
                        <Form className='w-100'>
                          <button
                            type='button'
                            id='nylasMicrosoft'
                            className='btn btn-lg rounded d-flex justify-content-center w-100'
                            style={{ border: '1px solid #4776E6', color: '#4776E6' }}
                            onClick={() => {
                              setaccountType('microsoft')
                              handleIsActive()
                            }}
                          >
                            <img
                              src={toAbsoluteUrl('/media/auth/microsoft-365-logo.svg')}
                              alt='Microsoft'
                              height={21}
                              width={21}
                              style={{ marginRight: '8px' }}
                            />
                            <p className='m-0 connected-acc-button-text'>
                              {formatMessage({ id: 'Connect Now' })}
                            </p>
                          </button>
                        </Form>
                      )
                    }}
                  </Formik>
                  <ConnectAccountModal
                    isActive={isActive}
                    setIsActive={setIsActive}
                    handleIsActive={handleIsActive}
                    accountType={accountType}
                    connectedAccount={connectedAccount}
                  />
                </div>
              </div>
            )
          ) : (connectedAccount === 'google' || connectedAccount === 'microsoft') && userInfo ? (
            <div className='d-flex flex-column justify-content-center align-items-start col-md-7 mb-10 mt-4'>
              <div
                className='btn-group d-flex flex-md-row flex-column  justify-content-between'
                role='group'
                aria-label='Connect buttons'
              >
                {userLoading ? (
                  <Skeleton
                    width={200}
                    style={{ width: '500px' }}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <button
                    type='button'
                    id='googleConnectButton'
                    className='btn btn-lg rounded d-flex justify-content-start '
                    style={{
                      border: '1px solid #4776E6',
                      color: '#4776E6',
                      fontFamily: 'Poppins',
                      fontWeight: '400',
                      fontSize: '13px',
                      lineHeight: '20px',
                      textAlign: 'right',
                    }}
                  >
                    <img
                      src={
                        connectedAccount === 'google'
                          ? toAbsoluteUrl('/media/auth/google-mini-logo.svg')
                          : toAbsoluteUrl('/media/auth/microsoft-365-logo.svg')
                      }
                      alt={connectedAccount}
                      height={21}
                      width={21}
                      style={{ marginRight: '8px' }}
                    />
                    <p
                      className='m-0 connected-acc-button-text'
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '13px',
                        lineHeight: '20px',
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {`${formatMessage({ id: 'Connected' })} ${userInfo}`}
                    </p>
                  </button>
                )}
              </div>
              {userLoading ? (
                <Skeleton
                  count={2}
                  width={500}
                  style={{ marginTop: '12px', width: '100%' }}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <>
                  <p
                    className='mt-2'
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: '400',
                      fontSize: '11px',
                      lineHeight: '20px',
                      color: '#585960',
                      marginBottom: '0px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {userName &&
                      `${formatMessage({ id: 'Connected by' })} ${userName} ${userEmail && `(${userEmail})`
                      }`}
                  </p>
                  <p
                    className='mt-0'
                    onClick={handleDisconnectButton}
                    style={{
                      color: '#4776E6',
                      fontFamily: 'Poppins',
                      fontWeight: '400',
                      fontSize: '11px',
                      lineHeight: '20px',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                  >
                    {formatMessage({ id: 'Disconnect Now' })}
                  </p>
                </>
              )}
            </div>
          ) : null}
          <ConfirmationModal
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            onConfirm={handleConfirmDisconnect}
            isProcessing={isProcessing}
          />
          {/* connected buttons */}
          {/* <div className='col-md-7 gap-4'>
            <button
              type='button'
              id='nylasMicrosoft'
              className='btn btn-lg rounded d-flex justify-content-center w-100 w-md-75 mb-3 connected-acc-button'
              // onClick={
              //   handleIsActive
              //   // redirectToNylasOauthUrl('microsoft')
              // }
            >
              <img
                src={toAbsoluteUrl('/media/auth/google-mini-logo.svg')}
                alt='Microsoft'
                height={21}
                width={21}
                style={{marginRight: '8px'}}
              />
              <p className='m-0 connected-acc-button-text'>
                {formatMessage({id: 'Connected me@toshendra.com'})}
              </p>
            </button>
            <button
              type='button'
              id='nylasMicrosoft'
              className='btn btn-lg rounded d-flex justify-content-center w-100 w-md-75 mb-3 connected-acc-button'
              // onClick={
              //   handleIsActive
              //   // redirectToNylasOauthUrl('microsoft')
              // }
            >
              <img
                src={toAbsoluteUrl('/media/auth/microsoft-365-logo.svg')}
                alt='Microsoft'
                height={21}
                width={21}
                style={{marginRight: '8px'}}
              />
              <p className='m-0 connected-acc-button-text'>
                {formatMessage({id: 'Connected me@toshendra.com'})}
              </p>
            </button>
            <p className='m-0 mb-2'>
              {formatMessage({id: 'Connected on 5 Jan, 2024 at 3:45 PM by Toshendra Sharma '})}
              (me@toshendra.com)
            </p>
            <p className='m-0 mb-2 text-primary cursor-pointer text-decoration-underline'>
              {formatMessage({id: 'Disconnect Now'})}
            </p>
          </div> */}
        </div>
      </div>
    </>
  )
}
